import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { MenuItem } from "@mui/material";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import React from "react";

function JSBorderStyle({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"none"} value={""}>
          None
        </MenuItem>,
        <MenuItem key={"solid"} value={"solid"}>
          Solid
        </MenuItem>,
        <MenuItem key={"dotted"} value={"dotted"}>
          Dotted
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSBorderStyleComponent: JSInputComponent = {
  Component: JSBorderStyle,
  handlesCssProperties: ["borderStyle"],
};
